<template>
  <v-menu offset-y v-if="isLoggedIn">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text outlined v-bind="attrs" v-on="on">
        <v-icon>{{ mdiAccountDetailsOutline }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-title>
          <v-btn text :to="{ name: 'app-ChangePassword' }">Change Password</v-btn>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <v-btn text :to="{ name: 'app-UserProfile' }">My Profile</v-btn>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <v-btn text :to="{ name: 'app-UserSettings' }">My Settings</v-btn>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-btn text @click="logout">{{ $t('common.logoff') }}</v-btn>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mdiAccountDetailsOutline } from '@mdi/js';

export default {
  module: 'auth',
  name: 'Account',
  data() {
    return {
      mdiAccountDetailsOutline,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('auth', ['username']),
  },
  methods: {
    ...mapActions('auth', ['LOGOUT_auth']),
    logout() {
      this.$root.$emit('auth:logoff');
    },
  },
};
</script>
